import { componentIdentityMap } from "./constants.js";
function identifyElement(element) {
  const dataTidal = element.getAttribute("data-tidal");
  if (dataTidal !== null) {
    return dataTidalToComponentType(dataTidal);
  }
  const muiComponentName = getMuiComponentName(element);
  if (muiComponentName !== null) {
    return identifyMuiElement(muiComponentName);
  }
  return componentIdentityMap.nonDs;
}
function dataTidalToComponentType(dataTidal) {
  switch (dataTidal) {
    case "TidalTag":
    case "TidalIcon":
    case "TidalChip":
    case "TidalChipMenu":
    case "TidalEditor":
    case "TidalEditorQuickInsertItem":
    case "TidalEditorToolbarButton":
    case "TidalEditorToolbarSelect":
    case "TidalEditorToolbarToggleButton":
    case "TidalSelect":
    case "TidalMultiSelect":
    case "TidalSimpleSelect":
    case "TidalTimePicker":
    case "CalendarDay":
      return componentIdentityMap.tidalInput;
    case "DateCalendar":
    case "RangeCalendar":
    case "CalendarMonth":
    case "TidalDetailRow":
    case "TidalSection":
    case "TidalCardExpandCollapse":
      return componentIdentityMap.tidalDataDisplay;
    case "TidalEditorQuickInsertToolbar":
    case "TidalEditorToolbar":
    case "TidalForgotPasswordForm":
    case "TidalResetPasswordForm":
    case "TidalLoginForm":
    case "TidalLoginFormContainer":
      return componentIdentityMap.tidalLayout;
    case "ActionBar":
    case "TidalActionBar":
    case "TidalActionHeader":
    case "CalendarNavigator":
    case "TidalHighlighter":
    case "TruncateList":
    case "TidalResizer":
    case "TidalMiddleEllipsis":
    case "Scrollbar":
    case "SnackMachine":
    case "TidalSnackMachine":
      return componentIdentityMap.tidalUtil;
    // return componentIdentityMap.tidalNavigation
    case "Card":
    case "TidalCard":
      return componentIdentityMap.tidalSurface;
    default:
      console.log(`no match for data-tidal="${dataTidal}"`);
      return componentIdentityMap.tidalUnknown;
  }
}
const muiClassName = /(Mui[A-Za-z]+)/g;
function getMuiComponentName(element) {
  const className = element.getAttribute("class");
  if (!className) return null;
  const lastMatch = className.match(muiClassName)?.at(-1) ?? null;
  return lastMatch;
}
function identifyMuiElement(muiName) {
  switch (muiName) {
    case "MuiAutocomplete":
    case "MuiButtonBase":
    case "MuiButton":
    case "MuiButtonGroup":
    case "MuiCheckbox":
    case "MuiFab":
    case "MuiFilledInput":
    case "MuiFormControl":
    case "MuiFormControlLabel":
    case "MuiFormGroup":
    case "MuiFormHelperText":
    case "MuiFormLabel":
    case "MuiInputAdornment":
    case "MuiInputBase":
    case "MuiInput":
    case "MuiInputLabel":
    case "MuiIconButton":
    case "MuiToggleButton":
    case "MuiToggleButtonGroup":
    case "MuiRadio":
    case "MuiRating":
    case "MuiSelect":
    case "MuiSlider":
    case "MuiSpeedDial":
    case "MuiSpeedDialIcon":
    case "MuiSwitch":
    case "MuiTextField":
    case "MuiNativeSelect":
    case "MuiOutlinedInput":
      return componentIdentityMap.muiInput;
    case "MuiAvatar":
    case "MuiAvatarGroup":
    case "MuiBadge":
    case "MuiChip":
    case "MuiDivider":
    case "MuiIcon":
    case "MuiList":
    case "MuiListItemAvatar":
    case "MuiListItemButton":
    case "MuiListItem":
    case "MuiListItemIcon":
    case "MuiListItemSecondaryAction":
    case "MuiListItemText":
    case "MuiListSubheader":
    case "MuiSvgIcon":
    case "MuiTableBody":
    case "MuiTableCell":
    case "MuiTable":
    case "MuiTableContainer":
    case "MuiTableFooter":
    case "MuiTableHead":
    case "MuiTablePagination":
    case "MuiTableRow":
    case "MuiTableSortLabel":
    case "MuiTypography":
      return componentIdentityMap.muiDataDisplay;
    case "MuiAlert":
    case "MuiAlertTitle":
    case "MuiBackdrop":
    case "MuiDialog":
    case "MuiDialogActions":
    case "MuiDialogContent":
    case "MuiDialogContentText":
    case "MuiDialogTitle":
    case "MuiCircularProgress":
    case "MuiLinearProgress":
    case "MuiSkeleton":
    case "MuiSnackbar":
    case "MuiSnackbarContent":
      return componentIdentityMap.muiFeedback;
    case "MuiAccordion":
    case "MuiAccordionActions":
    case "MuiAccordionDetails":
    case "MuiAccordionSummary":
    case "MuiAppBar":
    case "MuiCard":
    case "MuiCardActionArea":
    case "MuiCardActions":
    case "MuiCardContent":
    case "MuiCardHeader":
    case "MuiCardMedia":
    case "MuiPaper":
    case "MuiToolbar":
      return componentIdentityMap.muiSurface;
    case "MuiBottomNavigation":
    case "MuiBottomNavigationAction":
    case "MuiBreadcrumbs":
    case "MuiDrawer":
    case "MuiLink":
    case "MuiMenu":
    case "MuiMenuItem":
    case "MuiPagination":
    case "MuiPaginationItem":
    case "MuiStep":
    case "MuiStepper":
    case "MuiMobileStepper":
    case "MuiStepButton":
    case "MuiStepConnector":
    case "MuiStepContent":
    case "MuiStepIcon":
    case "MuiStepLabel":
    case "MuiTab":
    case "MuiTabScrollButton":
    case "MuiTabs":
      return componentIdentityMap.muiNavigation;
    case "MuiBox":
    case "MuiContainer":
    case "MuiImageList":
    case "MuiImageListItemBar":
    case "MuiImageListItem":
    case "MuiGrid2":
    case "MuiGrid":
    case "MuiStack":
      return componentIdentityMap.muiLayout;
    case "MuiCollapse":
    case "MuiModal":
    case "MuiPopover":
    case "MuiScopedCssBaseline":
    case "MuiTouchRipple":
      return componentIdentityMap.muiUtil;
    default:
      return componentIdentityMap.muiUnknown;
  }
}
export {
  identifyElement
};
//# sourceMappingURL=identifyElement.js.map
